import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import AdvertisementOwnerProfileStore from "../../stores/AdvertismentOwnerProfileStore";
import ShareableContactInformationView from "../views/ShareableContactInformationView";
import LoadingView from "../views/LoadingView";

class AdvertisementOwnerProfileContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "advertisementOwnerProfileStore": AdvertisementOwnerProfileStore.getState(),
        }
    }

    componentDidMount() {
        this.advertisementOwnerProfileStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.ADVERTISEMENT_OWNER_PROFILE_STORE_UPDATE, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.ADVERTISEMENT_OWNER_PROFILE_VIEW_MOUNTED, {"advertisementId" :this.props.match.params.id})
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.advertisementOwnerProfileStoreSubscriber);
        EventPublisher.publish(UIInteractionEvents.ADVERTISEMENT_OWNER_PROFILE_UNMOUNT, {});
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "advertisementOwnerProfileStore": AdvertisementOwnerProfileStore.getState(),
        });
    };

    render() {
        if (this.state.advertisementOwnerProfileStore.loadingState === LoadingStates.INITIALIZED) {
            return (
                <LoadingView titleText="Loading Advertiser"/>
            );
        }

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div>
                                <ShareableContactInformationView
                                    displayName={this.state.advertisementOwnerProfileStore.displayName}
                                    phoneNumber={this.state.advertisementOwnerProfileStore.phoneNumber}
                                    about={this.state.advertisementOwnerProfileStore.about}
                                    email={this.state.advertisementOwnerProfileStore.email}
                                    header={"Advertisement Owner Contact Information"}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AdvertisementOwnerProfileContainer;